import type { IconGlyph } from '../icon';

/**
 * Tractie `plus-thick` glyph (medium, 24×24), shown on the current nav item.
 *
 * Source: `@tractie/icons` v1.5.0, `dist/jsx/m/plus-thick.jsx`.
 * Verbatim copy of the SVG `d` attribute.
 */
export const iconPlusThick: IconGlyph = {
  name: 'plus-thick',
  path: 'M19 11h-6V5c0-.55-.45-1-1-1s-1 .45-1 1v6H5c-.55 0-1 .45-1 1s.45 1 1 1h6v6c0 .55.45 1 1 1s1-.45 1-1v-6h6c.55 0 1-.45 1-1s-.45-1-1-1',
};
